/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  GeneratePasswordResetTicketRequestDto,
  GeneratePasswordResetTicketResponseDto
} from '.././model';

import { customAxiosInstance } from '../../axios/axiosInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Generate password reset ticket
 */
export const generatePasswordResetTicket = (
    generatePasswordResetTicketRequestDto: GeneratePasswordResetTicketRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GeneratePasswordResetTicketResponseDto>(
      {url: `/password-reset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generatePasswordResetTicketRequestDto, signal
    },
      options);
    }
  


export const getGeneratePasswordResetTicketMutationOptions = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generatePasswordResetTicket>>, TError,{data: GeneratePasswordResetTicketRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof generatePasswordResetTicket>>, TError,{data: GeneratePasswordResetTicketRequestDto}, TContext> => {

const mutationKey = ['generatePasswordResetTicket'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generatePasswordResetTicket>>, {data: GeneratePasswordResetTicketRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  generatePasswordResetTicket(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GeneratePasswordResetTicketMutationResult = NonNullable<Awaited<ReturnType<typeof generatePasswordResetTicket>>>
    export type GeneratePasswordResetTicketMutationBody = GeneratePasswordResetTicketRequestDto
    export type GeneratePasswordResetTicketMutationError = null | null

    /**
 * @summary Generate password reset ticket
 */
export const useGeneratePasswordResetTicket = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generatePasswordResetTicket>>, TError,{data: GeneratePasswordResetTicketRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generatePasswordResetTicket>>,
        TError,
        {data: GeneratePasswordResetTicketRequestDto},
        TContext
      > => {

      const mutationOptions = getGeneratePasswordResetTicketMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    